<template>
	<div
		:class="$style['skeleton-column']"
		:style="styles"
	>
		<slot />
	</div>
</template>

<script>
export default {
	name: 'SkeletonColumn',
	props: {
		gutter: {
			type: String,
			default: '10px'
		},
		width: {
			type: String,
			default: '100%'
		},
		custom: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		styles () {
			const styles = {}

			if (this.width !== '100%') {
				styles.minWidth = this.width
			}

			styles.flex = this.width === '100%' ? 1 : `0 0 ${this.width}`

			styles.padding = `0 ${this.gutter}`

			return { ...styles, ...this.custom }
		}
	}
}
</script>

<style lang="scss" module>
.skeleton-column {
		flex: 1;
		display: flex;
		flex-flow: column;
	}
</style>
